import React from 'react';
import classNames from 'classnames';
import { Text } from '@moda/om';
import { LineItem } from '../../hooks/useCart/cart.rest';
import { LineItemFull } from '../LineItem';
import { hasError } from './hasError';
import './LineItemListFull.scss';

type Props = {
  title?: string;
  theme?: 'box' | 'simple';
  items: LineItem[];
};

export const LineItemListFull: React.FC<Props> = ({ title, theme = 'box', items }) => (
  <div
    className={classNames('LineItemListFull', `LineItemListFull--${theme}`, {
      'LineItemListFull--error': hasError(items)
    })}
  >
    {title ? (
      <h6 className="LineItemListFull__title">{title}</h6>
    ) : (
      <div className="LineItemListFull__title-placeholder" />
    )}
    {theme === 'box' && (
      <>
        <Text treatment="eyebrow" />
        <Text treatment="eyebrow">Product</Text>
        <Text treatment="eyebrow">Size</Text>
        <Text treatment="eyebrow">Qty</Text>
        <Text className="LineItemListFull__price-header" treatment="eyebrow">
          Price
        </Text>
        <div className="LineItemListFull__header-divider" />
      </>
    )}
    {items.map((item, index) => (
      <LineItemFull key={item.id} theme={theme} item={item} index={index} />
    ))}
  </div>
);
